module.exports = __webpack_public_path__ + "media/images/front/sp/default/doctor_profile_noimage-e82e7a4b9b4d91c567d0e33998116be2.png";